// situacao do contrato cruzando o portal com o servidor AFV (AfvController da API)
export const NOMES_SITUACAO = {
  OK: 'OK',
  SEM_MODULO: 'Sem módulo AFV',
  INATIVO: 'Cliente inativo',
  SEM_CLIENTE: 'Sem cliente no portal',
  NAO_CRIADO: 'Não criado',
};

export const CORES_SITUACAO = {
  OK: '#28a745',
  SEM_MODULO: '#dc3545',
  INATIVO: '#dc3545',
  SEM_CLIENTE: '#dc3545',
  NAO_CRIADO: '#6c757d',
};

export const OPCOES_SITUACAO = [
  { label: 'Todas', value: '' },
  { label: 'Lixo (sem módulo, inativo ou sem cliente)', value: 'LIXO' },
  ...Object.keys(NOMES_SITUACAO).map(k => ({ label: NOMES_SITUACAO[k], value: k })),
];

export const SITUACOES_LIXO = ['SEM_MODULO', 'INATIVO', 'SEM_CLIENTE'];

export const NOMES_CONTAINER = {
  running: 'Rodando',
  exited: 'Parado',
  created: 'Criado',
  restarting: 'Reiniciando',
  paused: 'Pausado',
  dead: 'Com falha',
  inexistente: 'Sem container',
};

export const CORES_CONTAINER = {
  running: '#28a745',
  exited: '#fd7e14',
  restarting: '#17a2b8',
  dead: '#dc3545',
};

// o que cada acao faz, para a confirmacao
export const ACOES = {
  iniciar: {
    titulo: 'Iniciar AFV',
    texto:
      'Liga o container. Se o contrato ainda não tem AFV, cria o banco, a pasta e o container (leva alguns minutos).',
  },
  parar: {
    titulo: 'Parar AFV',
    texto:
      'Para o container. Os dados ficam; o aplicativo do cliente para de sincronizar até iniciar de novo.',
  },
  reiniciar: { titulo: 'Reiniciar AFV', texto: 'Reinicia o container.' },
  backup: { titulo: 'Backup do AFV', texto: 'Gera um backup do banco do AFV no servidor.' },
  limpar: {
    titulo: 'Limpar dados do AFV',
    texto:
      'Faz backup e APAGA os dados do AFV (clientes, produtos, vendas, aparelhos, empresa...). Fica só o usuário 1. ' +
      'Depois, no Gerencial do cliente, sincronize o cadastro com a opção "Tudo".',
    destrutiva: true,
  },
  remover: {
    titulo: 'Remover AFV',
    texto:
      'Faz backup e REMOVE o container, a imagem e o banco do AFV. A pasta vai para "removidos" no servidor.',
    destrutiva: true,
  },
};
